import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

import SharePopup from './SharePopup';

import styles from './css/Sidebar.module.css';

export default function Sidebar({ isMenu, setIsMenu }) {
    const sidebarMainItems = {
        'guest': [
            { title: "로그인", to: "/login", icon: "/imgs/house.png", onClick: () => setIsMenu(false) },
            { title: "행정마당 이란?", to: "/about", icon: "/imgs/document_info.png", onClick: () => setIsMenu(false) },
        ],
        'default': [
            { title: "내 견적정보", to: "/quote_list", icon: "/imgs/document_check.png", onClick: () => setIsMenu(false) },
            { title: "행정마당 이란?", to: "/about", icon: "/imgs/document_info.png", onClick: () => setIsMenu(false) },
        ],
        'member': [
            { title: "의뢰정보", to: "/quote_list", icon: "/imgs/document_check.png", onClick: () => setIsMenu(false) },
            { title: "구독 설정", to: "/subscription", icon: "/imgs/sub_setting.png", onClick: () => setIsMenu(false) },
        ]
    };
    const sidebarSubItems = {
        'guest': [
            { title: "고객센터", to: "/agent", onClick: () => setIsMenu(false) },
            { title: "카카오톡 문의하기", onClick: () => {
                // eslint-disable-next-line
                OpenUrl.postMessage('http://pf.kakao.com/_xeKSPn');
                /*window.open('http://pf.kakao.com/_xeKSPn');*/
            }},
            { title: "이용방법", onClick: () => {
                // eslint-disable-next-line
                OpenUrl.postMessage('https://xn--ok1b32k1onu7m.com/use');
                /*window.open('https://xn--ok1b32k1onu7m.com/use');*/
            }},
            // { title: "공유하기", onClick: () => { setShowSharePopup(true) } },
        ],
        'default': [
            { title: "무료 견적 요청", to: "/quote?defaultJob=immigration", onClick: () => setIsMenu(false) },
            { title: "고객센터", to: "/agent", onClick: () => setIsMenu(false) },
            { title: "알림설정", to: "/alert", onClick: () => setIsMenu(false) },
            { title: "카카오톡 문의하기", onClick: () => {
                // eslint-disable-next-line
                OpenUrl.postMessage('http://pf.kakao.com/_xeKSPn');
                /*window.open('http://pf.kakao.com/_xeKSPn');*/
            }},
            { title: "이용방법", onClick: () => {
                // eslint-disable-next-line
                OpenUrl.postMessage('https://xn--ok1b32k1onu7m.com/use');
                /*window.open('https://xn--ok1b32k1onu7m.com/use');*/
            }},
            // { title: "공유하기", onClick: () => { setShowSharePopup(true) } },
        ],
        'member': [
            { title: "내 프로필", to: "/profile/member", onClick: () => {setIsMenu(false);} },
            { title: "고객센터", to: "/agent", onClick: () => {setIsMenu(false);} },
            { title: "알림설정", to: "/alert", onClick: () => {setIsMenu(false);} },
            { title: "카카오톡 문의하기", onClick: () => {
                // eslint-disable-next-line
                OpenUrl.postMessage('http://pf.kakao.com/_xeKSPn');
                /*window.open('http://pf.kakao.com/_xeKSPn');*/
            }},
            { title: "이용방법", onClick: () => {
                // eslint-disable-next-line
                OpenUrl.postMessage('https://xn--ok1b32k1onu7m.com/use');
                /*window.open('https://xn--ok1b32k1onu7m.com/use');*/
            }},
            // { title: "공유하기", onClick: () => { setShowSharePopup(true); } },
        ]
    };

    const [showSharePopup, setShowSharePopup] = useState(false);
    // 팝업 외부 스크롤 방지
    useEffect(() => {
        if (showSharePopup || isMenu) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
    }, [showSharePopup, isMenu]);

    const [userType, setUserType] = useState('guest');
    // set userType in Start
    useEffect(() => {
        const user = localStorage.getItem('user');
        if (user) setUserType(user);
        else setUserType('guest');
    }, []);

    function logout() {
        axios
            .post('/api/users/logout', {})
            .finally(() => window.location.href = '/');

        localStorage.setItem('user', 'guest');
        setIsMenu(false);
    }

    return (
        <div>
            <SharePopup showSharePopup={showSharePopup} setShowSharePopup={setShowSharePopup} />
            <div className={styles.sidebar} style={{ display: isMenu ? 'block' : 'none' }}>
                {/* Close Sidebar Button */}
                <div onClick={() => setIsMenu(false)} className={styles.sidebar_closeBtn}></div>
                {/* Sidebar Title */}
                <div className={styles.sidebar_title_box}>
                    <img src="/imgs/logo.png" alt="logo" />
                    <span>행정마당</span>
                </div>
                {/* Main Items */}
                <div className={styles.sidebar_main_box}>
                    {
                        (sidebarMainItems[userType]).map((item, index) => (
                            <div key={index} onClick={item.onClick} className={styles.sidebar_main_item}>
                                <Link to={item.to}>
                                    <img src={item.icon} alt={item.title} />
                                    <span className={styles.sidebar_inner_button}>{item.title}</span>
                                </Link>
                            </div>
                        ))
                    }
                </div>
                {/* Sub Items */}
                <div className={styles.sidebar_sub_box}>
                    {sidebarSubItems[userType].map((i, _key) => (
                        <div key={_key} className={styles.sidebar_sub_item}>
                            <Link to={i.to}>
                                <button onClick={i.onClick}>{i.title}</button>
                            </Link>
                        </div>
                    ))}
                </div>
                {/* Login or Logout Button */}
                <div className={styles.sidebar_loginBox}>
                    {
                        (userType === 'guest') ?
                        <Link onClick={() => setIsMenu(false)} to='/login'>로그인</Link>
                        :
                        <span onClick={logout}>로그아웃</span>
                    }
                </div>
            </div>
        </div>
    );
}